import React from "react";
import { useDispatch } from 'react-redux';

import { raiseToast } from '../services/redux/reducers/toast/toast'

const CopyToClipboard = (props) =>{

    const {text} = props

    const dispatch = useDispatch()

    const handleCopyClick = (text) => {
        if(text){
            navigator.clipboard.writeText(text)
            .then(() => {
                return dispatch(raiseToast({severity:'success', detail: "Copied!", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', detail: "Can't copy", life: 3000}))
            })
        }
    }

    return(
        <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(text)}></i>
    )
}

export default CopyToClipboard
